import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SocialMedia from "../SocailMedia";
import "./index.css";

function Footer() {
  return (
    <Container className="footer" id="about">
      <Container>
        <Row>
          <Col md={12} className="footer-about-social">
            <h1>Get in Touch</h1>
            <p>
              {" "}
              Whether you're looking to connect or discuss a project
              collaboration.
              <br />
              <strong>Feel free to connect with me</strong>
            </p>
            <SocialMedia />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Footer;
